import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { TimeRange } from 'features/systemLens'
import React, { createContext, useContext, useState } from 'react'
import { BaseSensorEntry } from 'types'

dayjs.extend(utc)

interface CompositeTimeSeriesAnalysisContextType {
  selectedSensors: BaseSensorEntry[]
  setSelectedSensors: React.Dispatch<
    React.SetStateAction<
      CompositeTimeSeriesAnalysisContextType['selectedSensors']
    >
  >
  sensorEntries: BaseSensorEntry[]
  isLoadingSensors: boolean
  timeRange: TimeRange
  setTimeRange: React.Dispatch<React.SetStateAction<TimeRange>>
}

const CompositeTimeSeriesAnalysisContext = createContext<
  CompositeTimeSeriesAnalysisContextType | undefined
>(undefined)

export const useCompositeTimeSeriesAnalysisContext = () => {
  const context = useContext(CompositeTimeSeriesAnalysisContext)
  if (!context) {
    throw new Error(
      'useCompositeTimeSeriesAnalysisContext must be used within CompositeTimeSeriesAnalysisProvider'
    )
  }
  return context
}

interface CompositeTimeSeriesAnalysisProviderProps {
  children: React.ReactNode
  sensorEntries: BaseSensorEntry[]
  timeRange: TimeRange
  setTimeRange: React.Dispatch<React.SetStateAction<TimeRange>>
  isLoadingSensors?: boolean
}

export const CompositeTimeSeriesAnalysisProvider: React.FC<
  CompositeTimeSeriesAnalysisProviderProps
> = ({
  children,
  sensorEntries,
  timeRange,
  setTimeRange,
  isLoadingSensors = false,
}) => {
  const [selectedSensors, setSelectedSensors] = useState<BaseSensorEntry[]>([])

  return (
    <CompositeTimeSeriesAnalysisContext.Provider
      value={{
        selectedSensors,
        setSelectedSensors,
        sensorEntries,
        isLoadingSensors,
        timeRange,
        setTimeRange,
      }}>
      {children}
    </CompositeTimeSeriesAnalysisContext.Provider>
  )
}
